import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
const GET_BUSINESS_UNITS_FIELD_NAME = 'businessUnits';
const GET_BUSINESS_UNITS = registerQuery({
  fieldName: GET_BUSINESS_UNITS_FIELD_NAME,
  fetcher() {
    return http.get('business-units/v1/business-unit-displays/user/dropdown');
  }
});
export default function useFetchBusinessUnits() {
  const {
    data,
    error,
    loading
  } = useQuery(GET_BUSINESS_UNITS);
  return {
    data: data && GET_BUSINESS_UNITS_FIELD_NAME in data && Array.isArray(data[GET_BUSINESS_UNITS_FIELD_NAME]) ? data[GET_BUSINESS_UNITS_FIELD_NAME] : [],
    error,
    loading
  };
}